import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserProfile } from "@/lib/storage";

interface Props {
  profile: UserProfile;
  onChange: (profile: UserProfile) => void;
}

export default function PersonalInfoStep({ profile, onChange }: Props) {
  const update = (field: keyof UserProfile['personal'], value: string) => {
    onChange({ ...profile, personal: { ...profile.personal, [field]: value } });
  };

  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-display font-bold text-lg text-foreground">Personal Information</h2>
        <p className="text-sm text-muted-foreground mt-1">Let's start with the basics.</p>
      </div>
      <div className="space-y-3">
        <div>
          <Label htmlFor="fullName" className="text-xs font-medium text-muted-foreground">Full Name</Label>
          <Input id="fullName" placeholder="John Doe" value={profile.personal.fullName} onChange={e => update('fullName', e.target.value)} className="mt-1" />
        </div>
        <div>
          <Label htmlFor="email" className="text-xs font-medium text-muted-foreground">Email</Label>
          <Input id="email" type="email" placeholder="john@example.com" value={profile.personal.email} onChange={e => update('email', e.target.value)} className="mt-1" />
        </div>
        <div>
          <Label htmlFor="phone" className="text-xs font-medium text-muted-foreground">Phone</Label>
          <Input id="phone" placeholder="+1 (555) 000-0000" value={profile.personal.phone} onChange={e => update('phone', e.target.value)} className="mt-1" />
        </div>
        <div>
          <Label htmlFor="location" className="text-xs font-medium text-muted-foreground">Location</Label>
          <Input id="location" placeholder="San Francisco, CA" value={profile.personal.location} onChange={e => update('location', e.target.value)} className="mt-1" />
        </div>
        <div>
          <Label htmlFor="linkedIn" className="text-xs font-medium text-muted-foreground">LinkedIn URL</Label>
          <Input id="linkedIn" placeholder="linkedin.com/in/johndoe" value={profile.personal.linkedIn} onChange={e => update('linkedIn', e.target.value)} className="mt-1" />
        </div>
        <div>
          <Label htmlFor="portfolio" className="text-xs font-medium text-muted-foreground">Portfolio Website</Label>
          <Input id="portfolio" placeholder="johndoe.com" value={profile.personal.portfolio} onChange={e => update('portfolio', e.target.value)} className="mt-1" />
        </div>
      </div>
    </div>
  );
}
